module.exports = __webpack_public_path__ + "static/media/sembawang-back.d4acacd9.png";